'use strict';

const ChartUtil = {
    sumC3Column: function(column=[]) {
        if (!column.length) return 0;

        let sum = 0;
        for (let i = 1; i < column.length; ++i) {
            sum += column[i];
        }

        return sum;
    },
};

module.exports = ChartUtil;